module.exports = __webpack_public_path__ + "static/index/img/baikal-410.d792b35f.jpg";